export enum UserProfile {
  Administrator = 'Administrador',
  Collaborator = 'Colaborador'
}
